import styled from 'styled-components';
import resultsBackground from '../../assets/backgrounds/Artboard_3.png';
import { fadeIn } from '../../utils/Animations';

export const Container = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  animation: ${fadeIn} 1s;
  animation-fill-mode: forwards;
  background: url(${resultsBackground}), ${({ theme }) => theme.colors.background};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-block: ${({ theme }) => `${theme.getValue(80)}`};

  p.questions-result {
    margin-top: ${({ theme }) => `${theme.getValue(25)}`};
    font-size: ${({ theme }) => `${theme.getFontSize(135)}`};
    text-align: center;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};
  }

  p.score-result {
    margin-top: ${({ theme }) => `${theme.getValue(25)}`};
    font-size: ${({ theme }) => `${theme.getFontSize(25)}`};
    text-align: center;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};
  }

  & aside {
    display: flex;
    flex-direction: column;
    row-gap: ${({ theme }) => `${theme.getValue(13)}`};
    padding-right: ${({ theme }) => `${theme.getValue(60)}`};
    max-width: ${({ theme }) => `${theme.getValue(383)}`};

    & > h2,
    & > h3 {
      color: ${({ theme }) => theme.colors.white};
      margin: 0;
      font-family: ${({ theme }) => theme.fonts.citiSans};
      font-weight: 700;
      text-align: center;
    }

    & h2 {
      font-size: ${({ theme }) => `${theme.getFontSize(25)}`};
      line-height: ${({ theme }) => `${theme.getFontSize(35)}`};
    }

    & h3 {
      font-size: ${({ theme }) => `${theme.getFontSize(20)}`};
      line-height: ${({ theme }) => `${theme.getFontSize(30)}`};
    }
  }

  & main {
    width: 100%;
    padding-inline: ${({ theme }) => theme.getValue(40)};
    display: flex;
    flex-direction: column;
    align-items: center;

    & > h1,
    & > h2,
    & > h3,
    & > p {
      text-align: center;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.white};
      margin: 0;
      color: ${({ theme }) => theme.colors.white};
      font-family: ${({ theme }) => theme.fonts.citiSans};
    }

    & > h1 {
      margin-top: ${({ theme }) => `${theme.getValue(20)}`};
      max-width: ${({ theme }) => `${theme.getValue(82)}`};
      font-size: ${({ theme }) => theme.getFontSize(37)};
      line-height: 0.82;
      font-weight: 400;
    }

    & > h2 {
      margin-top: ${({ theme }) => `${theme.getValue(20)}`};
      font-size: ${({ theme }) => `${theme.getFontSize(55)}`};
      font-weight: 700;
    }

    & > h3 {
      font-size: ${({ theme }) => `${theme.getFontSize(30)}`};
      font-weight: 700;
      text-transform: uppercase;
    }

    & div:last-child {
      display: flex;
      justify-content: center;
      margin-top: ${({ theme }) => `${theme.getValue(20)}`};

      & button {
        width: ${({ theme }) => `${theme.getValue(220)}`};
        text-transform: uppercase;
        font-weight: 700;
      }
    }
  }
`;
